import PropTypes from 'prop-types';
import LinearProgress from '@mui/material/LinearProgress';

import classes from './UserProgressBar.module.css';

/**
 * UserProgressBar component
 *
 * Displays the user's progress in the course as a percentage and a progress bar.
 * Calculates progress based on completed activities and total activities from lessons and user track.
 *
 * Props:
 * @param {object} userAditionalTrack - User's activity tracking data (expects userTrack array).
 * @param {object} lessons - Lessons data, including separators and lessons arrays.
 */
const UserProgressBar = ({ userAditionalTrack, lessons }) => {
  let allActivities = 0;
  let completeActivities = 0;
  // Calculate completed activities from userAditionalTrack.userTrack
  userAditionalTrack.userTrack.map(progress => {
    if (progress.media_play == 2) {
      completeActivities += 1;
    }
    if (progress.media_eval == 2) {
      completeActivities += 1;
    }
    if (progress.media_coeval >= 3) {
      completeActivities += 1;
    }
    if (progress.media_quiz == 2) {
      completeActivities += 1;
    }
  });
  // Calculate total activities from lessons.separators
  if (lessons.separators) {
    lessons.separators.map(folder => {
      folder.lessons.map(video => {
        allActivities += 1;
        if (video.hasEvaluation) {
          allActivities += 2;
        }
        if (video.idQuiz > 0) {
          allActivities += 1;
        }
      });
    });
  }
  // Calculate total activities from lessons.lessons
  if (lessons.lessons) {
    lessons.lessons.map(video => {
      allActivities += 1;
      if (video.hasEvaluation) {
        allActivities += 2;
      }
      if (video.idQuiz > 0) {
        allActivities += 1;
      }
    });
  }

  // TODO: Eliminar estas lineas cuando el back mande bien la info
  if (completeActivities > allActivities) {
    completeActivities = allActivities;
  }

  const progress = (completeActivities * 100) / allActivities;

  return (
    <div className={classes.progressBarContainer}>
      <span className={classes.progressText}>
        {progress.toFixed(2)}% Completado
      </span>
      {/* Passes progress value and custom styles to LinearProgress */}
      <LinearProgress
        classes={{
          barColorPrimary: classes.linearBarColorUser
        }}
        className={classes.progressBarUser}
        variant="determinate"
        value={progress.toFixed(2)}
      />
    </div>
  );
};

UserProgressBar.propTypes = {
  userAditionalTrack: PropTypes.shape({
    userTrack: PropTypes.arrayOf(
      PropTypes.shape({
        media_play: PropTypes.number,
        media_eval: PropTypes.number,
        media_coeval: PropTypes.number,
        media_quiz: PropTypes.number
      })
    )
  }),
  lessons: PropTypes.shape({
    separators: PropTypes.array,
    lessons: PropTypes.array
  })
};

UserProgressBar.defaultProps = {
  userAditionalTrack: { userTrack: [] },
  lessons: { separators: [], lessons: [] }
};

export default UserProgressBar;
